import indexConfig from "@/config/url.config.js";
export default {
	data () {
		return {
			websocket: null,
		}
	},
	//排序
	sortObj(obj) {
		// 使用Object.keys()获取对象的所有键，并排序
		let sortedKeys = Object.keys(obj).sort();
		// 使用reduce构造一个新的对象，这个对象的键按字母顺序排序
		let sortedObj = sortedKeys.reduce((sorted, key) => {
			sorted[key] = obj[key];
			return sorted;
		}, {});
		return sortedObj;
	},
	//初始化websocket
	initWebsocket() {
		var wsServer = indexConfig.wssUrl
		this.websocket = new WebSocket(wsServer);
		var websocket = this.websocket
		let that = this
		let timer = null
		websocket.onopen = function() {
			let param = {
				type: "login",
				token: that.getToken(),
			}
			websocket.send(JSON.stringify(param))

		};
		websocket.onmessage = function(evt) {
			let data = evt.data
			switch (data) {
				case "login_success":
					timer = setInterval(() => {
						websocket.send('ping');
					}, 5000);
					break;
			}
		};
		websocket.onclose = function() {
			if (timer) {
				clearInterval(timer)
			}
			console.log("Disconnected");
		};
	},
	getToken() {
		let certificate = localStorage.getItem('user_certificate')
		if (certificate) {
			certificate = JSON.parse(certificate)
			return certificate.access_token;
		}
		return '';
	},
	stopWebSocket() {
		this.websocket.close(); // 关闭WebSocket连接
	}
}